/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * Health Check Configuration
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

// Health check configuration using Vite-defined constants
import { createLogger } from '../utils/logger'

const logger = createLogger('healthConfig')

export const healthConfig = {
  // Enable/disable health checks (can be overridden by environment variables)
  enabled: typeof __HEALTH_CHECKS_ENABLED__ !== 'undefined' ? __HEALTH_CHECKS_ENABLED__ : true,

  // Health check interval (milliseconds) - increased to reduce proxy load
  checkInterval:
    typeof __HEALTH_CHECK_INTERVAL__ !== 'undefined' ? __HEALTH_CHECK_INTERVAL__ : 60000, // 1 minute instead of 30 seconds

  // Retry interval when offline (milliseconds)
  retryInterval:
    typeof __HEALTH_RETRY_INTERVAL__ !== 'undefined' ? __HEALTH_RETRY_INTERVAL__ : 10000,

  // Timeout for health check requests (milliseconds)
  timeout: typeof __HEALTH_TIMEOUT__ !== 'undefined' ? __HEALTH_TIMEOUT__ : 5000,

  // Show health banner in development mode only
  devOnly: typeof __HEALTH_DEV_ONLY__ !== 'undefined' ? __HEALTH_DEV_ONLY__ : false,

  // Health endpoint path
  endpoint: '/health'
}

// Helper function to check if health checks should be enabled
export const shouldEnableHealthChecks = () => {
  // Disabled by config
  if (!healthConfig.enabled) {
    logger.debug('🏥 Health checks disabled by configuration')
    return false
  }

  // Dev only mode - only enable in development
  if (healthConfig.devOnly && import.meta.env.PROD) {
    logger.debug('🏥 Health checks disabled in production (dev-only mode)')
    return false
  }

  return true
}

export default healthConfig
